(function () {
  'use strict';

  var MONTHS = 12;

  /* ---- helpers --------------------------------------------------------- */

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Turn "+0100" / "-0500" into the store's current local Date. */
  function storeNow(offsetStr) {
    var m = /^([+-])(\d{2})(\d{2})$/.exec(offsetStr || '');
    if (!m) return new Date();
    var offsetMinutes = (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
    var now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() + offsetMinutes) * 60000);
  }

  /* The set of visible tabs only changes when the month rolls over or the
     cut-off day passes. Same string the Liquid builds. */
  function tabsKey(date, cutoffDay) {
    return (
      date.getFullYear() +
      '-' +
      pad2(date.getMonth() + 1) +
      '-' +
      (date.getDate() > cutoffDay ? 'late' : 'early')
    );
  }

  /* ---- the section ----------------------------------------------------- */

  function TrialBox(root) {
    this.root = root;

    this.bindTabs();
    this.bindEvents();
    this.checkRenderedTabs();
  }

  /* 1. Month tabs --------------------------------------------------------- */

  TrialBox.prototype.bindTabs = function () {
    var self = this;
    this.tabs = Array.prototype.slice.call(this.root.querySelectorAll('[data-trial-box-tab]'));
    this.panels = Array.prototype.slice.call(this.root.querySelectorAll('[data-trial-box-panel]'));

    if (!this.tabs.length) return;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.selectMonth(tab.dataset.trialBoxTab, true);
      });

      // Arrow keys move between tabs, which is what a tablist should do.
      tab.addEventListener('keydown', function (event) {
        var i = self.tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = self.tabs[(i + 1) % self.tabs.length];
        if (event.key === 'ArrowLeft') next = self.tabs[(i - 1 + self.tabs.length) % self.tabs.length];
        if (event.key === 'Home') next = self.tabs[0];
        if (event.key === 'End') next = self.tabs[self.tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        self.selectMonth(next.dataset.trialBoxTab, true);
        next.focus();
      });
    });
  };

  /* focus=false is for the theme editor, which selects a block without the
     shopper having clicked anything. */
  TrialBox.prototype.selectMonth = function (id, updateTabIndex) {
    if (!id) return;

    this.tabs.forEach(function (tab) {
      var active = tab.dataset.trialBoxTab === id;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      if (updateTabIndex) tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach(function (panel) {
      panel.hidden = panel.dataset.trialBoxPanel !== id;
    });
  };

  /* 2. Events accordion --------------------------------------------------- */

  /* The design puts the toggle under the summary text, which <details> can't
     do, so each card is a button + aria-expanded pair. The Liquid ships every
     card closed; this only wires the controls. */
  TrialBox.prototype.bindEvents = function () {
    var self = this;

    this.root.querySelectorAll('[data-trial-box-event]').forEach(function (card) {
      var toggle = card.querySelector('[data-trial-box-event-toggle]');
      var body = card.querySelector('.trial-box__event-body');
      var chevron;

      if (!toggle) return;

      // Nothing to expand: this event has no summary text.
      if (!body) {
        toggle.removeAttribute('aria-expanded');
        toggle.removeAttribute('aria-controls');
        toggle.disabled = true;
        chevron = toggle.querySelector('.trial-box__chevron');
        if (chevron) chevron.parentNode.removeChild(chevron);
        return;
      }

      toggle.addEventListener('click', function () {
        self.setEventOpen(card, toggle, toggle.getAttribute('aria-expanded') !== 'true');
      });
    });

    this.syncEventRows();
  };

  TrialBox.prototype.setEventOpen = function (card, toggle, open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      card.removeAttribute('data-collapsed');
    } else {
      card.setAttribute('data-collapsed', '');
    }
    this.syncEventRows();
  };

  /* Grid items stretch to the tallest sibling, so a closed card would keep
     an open neighbour's height. Flag the row and let CSS stop stretching. */
  TrialBox.prototype.syncEventRows = function () {
    this.root.querySelectorAll('.trial-box__events').forEach(function (row) {
      if (row.querySelector('[data-collapsed]')) {
        row.setAttribute('data-any-collapsed', '');
      } else {
        row.removeAttribute('data-any-collapsed');
      }
    });
  };

  /* 3. Stale cache check -------------------------------------------------- */

  /* A page cached before the cut-off would keep showing a month that should
     have dropped off. Compare what the server rendered with what today's
     store-local date implies, and re-render from the server if they differ. */
  TrialBox.prototype.checkRenderedTabs = function () {
    var rendered = this.root.dataset.tabsKey;
    var cutoff = parseInt(this.root.dataset.cutoffDay, 10);
    if (!rendered || !cutoff) return;

    if (tabsKey(storeNow(this.root.dataset.storeOffset), cutoff) !== rendered) {
      this.refresh();
    }
  };

  TrialBox.prototype.refresh = function () {
    var self = this;
    var sectionId = this.root.dataset.sectionId;
    if (!sectionId || this.root.hasAttribute('data-tb-refreshed')) return;
    this.root.setAttribute('data-tb-refreshed', '');

    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now())
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-trial-box]');
        if (fresh) {
          fresh.setAttribute('data-tb-refreshed', '');
          self.root.replaceWith(fresh);
          init(fresh);
        } else {
          // No months qualify any more.
          self.root.remove();
        }
      })
      .catch(function () {
        /* Leave the current render in place — it is still a valid page. */
      });
  };

  /* ---- boot ------------------------------------------------------------ */

  function init(root) {
    if (!root || root.trialBox) return;
    root.trialBox = new TrialBox(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-trial-box]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init after a section is added, moved or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Theme editor: clicking a month block should switch to that month.
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-trial-box]');
    if (root && root.trialBox) {
      root.trialBox.selectMonth(event.target.dataset.trialBoxPanel, true);
    }
  });
})();